module.exports = __webpack_public_path__ + "static/media/place-3.d1ae0e02.png";